import axios from "@/plugins/axios";

export const state = () => ({
  warehouses: [],
});

export const mutations = {
  SET_WAREHOUSES(state, payload) {
    state.warehouses = payload;
  },
};

export const actions = {
  async fetchWarehouses({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/ware-houses")
        .then((res) => {
          commit("SET_WAREHOUSES", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
